import LinearProgressML from './LinearProgressML';
export default (props) => {
  return <LinearProgressML {...props} />;
};
